import {$, w} from './constants';
import './tabs.js';
import './gtm.js';
import './utm.js';
import { sliderGrab } from './sliders.js';
import {initFichas, pui} from './pui.js';

w.load(() => {
    console.log('Hello world from El Cultivo! --Load');

	if($('#chips').length){
		initFichas();
	}
});

$(document).ready(function() {
    console.log('Hello world from El Cultivo! --Ready');
    igualarAlturasTipos();
	sliderGrab();
	const nav = $(".header");
	/* M E N U: Scroll */
	w.scroll(function (event) {
		if($(this).scrollTop() > 0){
			$('.menu-item-has-children').removeClass('active');
		}
	});
	$('.menu-item-has-children').click(function(e){
		console.log('Log para click')
		e.preventDefault();
		e.stopPropagation();
		// Cierra todos los submenús excepto el actual
		$('.menu-item-has-children').not(this).removeClass('active');
		$(this).toggleClass('active');
	});
	$('.sub-menu').click(function(e){
		e.stopPropagation();
	});
	$('#open_menu').on('click', function(e){
		$('#header_mobile').fadeIn(200);
	});
	$('#close_menu').on('click', function(e){
		$('#header_mobile').fadeOut(100);
	});

	// Footer
	if($('.menu-item.footer_mobile_link').length ){
		updateFooterLogin();
	}

	//Pop Up Footer
	$('.pop_up_footer > a').on('click', function(e) {
		e.preventDefault();
		e.stopPropagation();
		$('#pop_up_footer').fadeIn(300);
	});
	
	$('.footer__pop-close').on('click', function(e) {
		$(this).parent().parent().parent().fadeOut(150);
	});

	$('.pop_up_footer_2 > a').on('click', function(e) {
		e.preventDefault();
		e.stopPropagation();
		$('#pop_up_footer_2').fadeIn(300);
	});
})

$(w).on('resize', function(){
    requestAnimationFrame(() => {
        igualarAlturasTipos();
    });
	// Footer
	if($('.menu-item.footer_mobile_link').length ){
		updateFooterLogin();
	}
})

/* C a r d s  M o d a l i d a d */
function igualarAlturasTipos() {
    const $blocks = $('#blocks_type');
	if (!$blocks.length) return; 
    
	const clases = ['.upper-container'];

	if (window.innerWidth <= 950){
        clases.forEach(function(clase) {
            $('.home-template__types-block ' + clase).css('height', 'auto');
        });
        return;
    }
	clases.forEach(function(clase) {
		// Reinicia alturas
		$('.home-template__types-block ' + clase).css('height', 'auto');

		// Agrupar en pares (2 columnas por fila)
		let items = $('.home-template__types-block');
		for (let i = 0; i < items.length; i += 2) {
			let $rowItems = items.slice(i, i + 2); // grupo de A-B, C-D, etc.
			let maxHeight = 0;

			$rowItems.find(clase).each(function() {
				let altura = $(this).outerHeight();
				if (altura > maxHeight) maxHeight = altura;
			});

			$rowItems.find(clase).height(maxHeight);
		}
	});
}

//Scroll en links de misma página
$('a[href*="#"]')
.not('[href="#"]')
.not('[href="#0"]')
.click(function(event) {
	if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
		let target = $(this.hash);
		target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

		if (target.length) {
			event.preventDefault();
			$('html, body').animate({
				scrollTop: target.offset().top - 100
			}, 1000);
		}
	}
});

function updateFooterLogin() {
	const $footerLink = $('.menu-item.footer_mobile_link > a');

	// Guarda la URL original en el atributo `data-original-link` si aún no está configurada
	if (!$footerLink.data('original-link')) {
		const originalLink = $footerLink.attr('href');
		$footerLink.attr('data-original-link', originalLink);
		$footerLink.data('original-link', originalLink);
	}

	const originalLink = $footerLink.data('original-link'); // URL original del escritorio
	const mobileLink = $footerLink.attr('title');		   // URL para móvil
	const idFooter = ['click_footer_abrir-cuenta_desk', 'click_footer_abrir-cuenta_mobile'];

	if ($(window).width() < 951) {
		$footerLink.attr('href', mobileLink);
		$footerLink.attr('id', idFooter[1]);
	} else {
		$footerLink.attr('href', originalLink);
		$footerLink.attr('id', idFooter[0]);
	}
}
